/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import { IconButton } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { NOTIFICATIONS_SLICE_NAME } from '../../../../../app/constants';
import { ReactComponent as RefreshIcon } from '../../../../../assets/images/refresh_icon.svg';
import ErrorHandler from '../../../../../common/components/ErrorHandler';
import CustomPagination from '../../../../../components/CustomPagination';
import WarningModal from '../../../../../components/WarningModal';
import { t, bareDateTimeFormat } from '../../../../../providers';
import { me as meSlice } from '../../../../AuthenticatedPage/authenticationSlice';
import {
    childAccounts as childAccountsSlice,
    loading as loadingSlice,
    selectedChildAccount as childAccountSlice,
    requestResult,
    error as errorSlice,
    errorActivateChildAccount as activateChildErrorSlice,
    errorDeactivateChildAccount as deactivateChildErrorSlice,
} from '../../../accountSlice';
import { SLICE_NAME } from '../../../constants';
import ActionsButton from './ActionsButton';
import ConfirmStatusChangeDialog from './ConfirmStatusChangeDialog';
import TableSortHead from './TableSortHead';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    tableContainer: {
        minHeight: '200px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        '@media (max-width:960px)': {
            width: 'calc(100vw - 60px)',
        },
    },
    row: {
        minHeight: '4rem',
    },
    name: {
        width: '15%',
        '&.MuiTableCell-body': {
            fontSize: '0.75rem',
            color: '#5D5D5D',
            lineHeight: '15.96px',
            fontWeight: '400',
        },
        '&.MuiTableCell-head': {
            fontSize: '0.75rem',
            textTransform: 'capitalize',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '133%',
            color: '#2E2E2E',
        },
    },
    userID: {
        width: '10%',
        '&.MuiTableCell-body': {
            fontSize: '0.75rem',
            color: '#5D5D5D',
            lineHeight: '15.96px',
            fontWeight: '400',
        },
        '&.MuiTableCell-head': {
            fontSize: '0.75rem',
            textTransform: 'capitalize',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '133%',
            color: '#2E2E2E',
        },
    },
    email: {
        width: '15%',
        '&.MuiTableCell-body': {
            fontSize: '0.75rem',
            color: '#5D5D5D',
            lineHeight: '15.96px',
            fontWeight: '400',
        },
        '&.MuiTableCell-head': {
            fontSize: '0.75rem',
            textTransform: 'capitalize',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '133%',
            color: '#2E2E2E',
        },
    },
    status: {
        width: '10%',
        '&.MuiTableCell-body': {
            fontSize: '0.75rem',
            color: '#5D5D5D',
            lineHeight: '15.96px',
            fontWeight: '400',
        },
        '&.MuiTableCell-head': {
            fontSize: '0.75rem',
            textTransform: 'capitalize',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '133%',
            color: '#2E2E2E',
        },
    },
    roles: {
        width: '25%',
        '&.MuiTableCell-body': {
            fontSize: '0.75rem',
            color: '#5D5D5D',
            lineHeight: '15.96px',
            fontWeight: '400',
        },
        '&.MuiTableCell-head': {
            fontSize: '0.75rem',
            textTransform: 'capitalize',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '133%',
            color: '#2E2E2E',
        },
    },
    rolesColumn: {
        display: 'flex',
        flexFlow: 'column nowrap',
        padding: '10px 0px',
    },
    lastLogin: {
        '&.MuiTableCell-body': {
            fontSize: '0.75rem',
            color: '#5D5D5D',
            lineHeight: '15.96px',
            fontWeight: '400',
        },
        '&.MuiTableCell-head': {
            fontSize: '0.75rem',
            textTransform: 'capitalize',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '133%',
            color: '#2E2E2E',
        },
        width: '22%',
    },
    actions: {
        width: '3%',
        '&.MuiTableCell-head': {
            fontSize: '0.75rem',
            textTransform: 'capitalize',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '133%',
            color: '#2E2E2E',
        },
    },
    inactiveRow: {
        minHeight: '4rem',
        '& .MuiTableCell-body': {
            color: theme.palette.text.inactiveChildGrey,
            fontWeight: '400',
        },
    },
    refreshButton: {
        color: '#3F5E20',
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '16px',
        letterSpacing: '0.5px',
        textAlign: 'left',
        padding: '0px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    optionsBtn: {
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
}));

const ASC = 'ASC';
const DESC = 'DESC';
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 0;
const DEFAULT_SORT_COLUMN = 'firstName';
const DEFAULT_SORT_TYPE = ASC;

const ChildAccountsTable = ({ globals, tableAriaLabel = '' }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const childAccounts = useSelector(childAccountsSlice);
    const loading = useSelector(loadingSlice);
    const selectedChildAccount = useSelector(childAccountSlice);
    const response = useSelector(requestResult);
    const me = useSelector(meSlice);
    const isTablet = useMediaQuery('(max-width:960px)');
    const error = useSelector(errorSlice);
    const deactivateChildError = useSelector(deactivateChildErrorSlice);
    const activateChildError = useSelector(activateChildErrorSlice);

    const { content, totalElements, size, number, lastUpdateDate } = childAccounts || {};

    const [sortProps, setSortProps] = useState({ sortColumn: null, sortType: ASC });

    const [dialogOpen, setDialogOpen] = useState(false);
    const [actionProps, setActionProps] = useState({ action: 'activate', account: null });
    const [errorDialog, setErrorDialog] = useState({ visibility: false, message: '', title: '' });
    const [errorHandler, setErrorHandler] = useState({ hasRefresh: false, message: '', subtitle: '' });

    const requestChildAccounts = () => {
        setErrorHandler({ hasRefresh: false, message: '', subtitle: '' });
        const sortColumn = DEFAULT_SORT_COLUMN;
        const sortType = DEFAULT_SORT_TYPE;
        const params = { page: DEFAULT_PAGE_NUMBER, size: DEFAULT_PAGE_SIZE, sortColumn, sortType };
        setSortProps({ sortColumn, sortType });
        dispatch({ type: `${SLICE_NAME}/requestChildAccounts`, payload: { params } });
    };

    useEffect(() => {
        const sortColumn = DEFAULT_SORT_COLUMN;
        const sortType = DEFAULT_SORT_TYPE;
        const params = { page: DEFAULT_PAGE_NUMBER, size: DEFAULT_PAGE_SIZE, sortColumn, sortType };
        setSortProps({ sortColumn, sortType });
        dispatch({ type: `${SLICE_NAME}/requestChildAccounts`, payload: { params } });
    }, [dispatch]);

    useEffect(() => {
        if (selectedChildAccount) {
            history.push('/child-accounts/edit');
        }
    }, [selectedChildAccount, history]);

    useEffect(() => {
        if (response && response.ok) {
            const { fromAction } = response;
            if (fromAction === 'activateChildAccount') {
                dispatch({
                    type: `${NOTIFICATIONS_SLICE_NAME}/addNotification`,
                    payload: { message: t('child.account.activate.success') },
                });
            }
            if (fromAction === 'deactivateChildAccount') {
                dispatch({
                    type: `${NOTIFICATIONS_SLICE_NAME}/addNotification`,
                    payload: { message: t('child.account.deactivate.success') },
                });
            }
            if (fromAction === 'activateChildAccount' || fromAction === 'deactivateChildAccount') {
                dispatch({ type: `${SLICE_NAME}/requestResult`, payload: null });
                dispatch({
                    type: `${SLICE_NAME}/requestChildAccounts`,
                    payload: { params: { size, page: number, ...sortProps } },
                });
            }
        }
    }, [response, dispatch, size, number, sortProps]);

    useEffect(() => {
        if (error && error !== null && error.extraInfo) {
            setErrorHandler({
                message: error.message,
                hasRefresh: error.extraInfo.hasRefresh || false,
                subtitle: error.extraInfo.secondMessage || '',
            });
        }
        if (deactivateChildError) {
            setErrorDialog({
                visibility: true,
                message: `${t(deactivateChildError.message)} ${t(deactivateChildError.extraInfo.secondMessage)}`,
                title: '',
            });
        }
        if (activateChildError) {
            setErrorDialog({
                visibility: true,
                message: `${t(activateChildError.message)} ${t(activateChildError.extraInfo.secondMessage)}`,
                title: '',
            });
        }
    }, [error, deactivateChildError, activateChildError]);

    const editAccount = (childAccount) => {
        dispatch({ type: `${SLICE_NAME}/selectedChildAccount`, payload: childAccount });
    };

    const resetDialog = () => {
        setActionProps({ title: '', description: '', account: null });
        setDialogOpen(false);
    };

    const setStatus = (childAccount) => {
        const action = 'activate';
        setActionProps({ action, account: childAccount });
        setDialogOpen(true);
    };

    const updateStatus = () => {
        if (actionProps) {
            const { username, enabled } = actionProps.account;
            dispatch({ type: `${SLICE_NAME}/${actionProps.action}ChildAccount`, payload: { userName: username, enabled: enabled } });
        }
        setDialogOpen(false);
    };

    const cancelUpdateStatus = () => {
        resetDialog();
    };

    const setSorting = (sortColumn) => {
        const isSameKey = sortColumn === sortProps.sortColumn;
        const oppositeSort = sortProps.sortType === ASC ? DESC : ASC;
        const sortType = !isSameKey ? ASC : oppositeSort;
        setSortProps({ sortColumn, sortType });
        const params = { sortColumn, sortType, size, page: DEFAULT_PAGE_NUMBER };
        dispatch({ type: `${SLICE_NAME}/requestChildAccounts`, payload: { params } });
    };

    const handleChangePage = (event, newPage) => {
        event.preventDefault();
        if (newPage !== number) {
            const params = { size, ...sortProps, page: newPage };
            dispatch({ type: `${SLICE_NAME}/requestChildAccounts`, payload: { params } });
        }
    };

    const handleChangeRowsPerPage = (event) => {
        const pageSize = event;
        if (size !== pageSize) {
            const params = { size: pageSize, ...sortProps, page: 0 };
            dispatch({ type: `${SLICE_NAME}/requestChildAccounts`, payload: { params } });
        }
    };

    const handleCloseDialog = () => {
        setErrorDialog({ visibility: false, message: '', title: '' });
        dispatch({ type: `${SLICE_NAME}/errorActivateChildAccount`, payload: false });
        dispatch({ type: `${SLICE_NAME}/errorDeactivateChildAccount`, payload: false });
    };

    const tableHead = (
        <TableSortHead classes={classes} setSorting={setSorting} sortBy={sortProps.sortColumn} sortValue={sortProps.sortType.toLowerCase()} />
    );

    return (
        <>
            {!loading ? (
                <>
                    {errorHandler.message !== '' && (
                        <ErrorHandler
                            title={errorHandler.message}
                            subtitle={errorHandler.subtitle}
                            action={
                                errorHandler.hasRefresh && (
                                    <IconButton
                                        disableFocusRipple
                                        className={classes.refreshButton}
                                        onClick={() => {
                                            requestChildAccounts();
                                        }}>
                                        {t('refresh.button.text')}
                                        <RefreshIcon style={{ paddingLeft: '6.68px' }} aria-hidden="true" focusable="false" />
                                    </IconButton>
                                )
                            }
                        />
                    )}
                    {errorHandler.message === '' && (
                        <TableContainer className={classes.tableContainer}>
                            <Table tabIndex={0} className={classes.table} id="table-child-accounts" aria-label={tableAriaLabel}>
                                {tableHead}
                                <TableBody>
                                    {(!content || content.length === 0) && (
                                        <TableRow className={classes.row}>
                                            <TableCell colSpan={6} align="center">
                                                {t('child.account.not.associated')}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {(content || []).map((child, chIdx) => {
                                        const rowClass = classes.row;
                                        return (
                                            <TableRow key={`${child.email}_${chIdx}`} className={rowClass}>
                                                <TableCell className={classes.name} align="left">
                                                    {child.firstName} {child.lastName}
                                                </TableCell>
                                                <TableCell className={classes.email} align="left">
                                                    {child.email}
                                                </TableCell>
                                                <TableCell className={classes.userID} align="left">
                                                    {child.username}
                                                </TableCell>
                                                <TableCell className={classes.status} align="left">
                                                    {child.enabled ? t('active') : t('inactive')}
                                                </TableCell>
                                                <TableCell className={classes.roles} align="left">
                                                    <div className={classes.rolesColumn}>
                                                        {child.inpiRoles.map((r, idx) => (
                                                            <span key={`${r}_${idx}`}>{t(r)}</span>
                                                        ))}
                                                    </div>
                                                </TableCell>
                                                <TableCell className={classes.actions} align="left">
                                                    <ActionsButton
                                                        className={classes.optionsBtn}
                                                        account={child}
                                                        globals={globals}
                                                        edit={editAccount}
                                                        setStatus={setStatus}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </>
            ) : (
                <Box display="flex" alignItems="center" justifyContent="center">
                    <CircularProgress aria-hidden="true" />
                    <Typography variant="srOnly" role="alert">
                        {t('loading.text')}
                    </Typography>
                </Box>
            )}
            {!!content && totalElements > 0 && (
                <CustomPagination
                    content={content}
                    defaultPageSize={DEFAULT_PAGE_SIZE}
                    totalElements={totalElements}
                    component={'div'}
                    count={totalElements || 0}
                    size={size || DEFAULT_PAGE_SIZE}
                    page={number || DEFAULT_PAGE_NUMBER}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    selectProps={{ renderValue: (value) => `${value} ${t('items')}` }}
                    paginationId={'childAccounts'}
                    isTablet={isTablet}
                    lastUpdateDate={lastUpdateDate}
                />
            )}
            <ConfirmStatusChangeDialog
                open={dialogOpen}
                onAccept={updateStatus}
                onCancel={cancelUpdateStatus}
                action={actionProps.account && actionProps.account.enabled ? 'deactivate' : 'activate'}
                childAccount={actionProps.account || {}}
            />
            {errorDialog.visibility && (
                <WarningModal
                    visibility={errorDialog.visibility}
                    message={errorDialog.message}
                    onConfirmation={handleCloseDialog}
                    confirmButtonText={t('export.unavailable.button')}
                    title={errorDialog.title}
                />
            )}
        </>
    );
};

export default ChildAccountsTable;
